import React from 'react';
import { Navigate } from 'react-router-dom';
import { ListingRoute } from '../../../../models';
import DefaultRouter, {
  underExternalAdministrationRoutes,
} from './default-router/router';
import ListingDetailsPreview from '../../../../common-pages/ListingDetailsPreview';

export default [
  {
    path: 'preview-mode',
    element: ListingDetailsPreview,
  },
  {
    path: 'default',
    element: DefaultRouter,
    routes: underExternalAdministrationRoutes,
  },
  { index: true, element: <Navigate to="default" replace /> },
] as Array<ListingRoute>;
